import { render, staticRenderFns } from "./ExtCustomer.vue?vue&type=template&id=cd756022&scoped=true&"
import script from "./ExtCustomer.vue?vue&type=script&lang=js&"
export * from "./ExtCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd756022",
  null
  
)

export default component.exports